<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    const handleFontSize = () => {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke('setFontSizeCallback', {fontSize: 0});
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on('menu:setfont', function() {
        WeixinJSBridge.invoke('setFontSizeCallback', {fontSize: 0});
      });
    };
    try {
      // 安卓 禁止用户自定义设置字体大小
      if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
        handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', handleFontSize);
          document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
        }
      }
    } catch (error) {}
    window.addEventListener(
      "hashchange",
      () => {
        let currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      },
      false
    );
  },
};
</script>

<style>
html,
body {
  height: 100%;
  width: 100%;
  overflow: hidden;
  margin: 0px;
  background-color: #e7e8e9;

  /* IOS 禁止用户自定义设置字体大小 */
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
#app {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue